const States = {
    1: [
      {
        'name': 'AL-Alabama',
        'abbreviation': 'AL'
      },
      {
        'name': 'AK-Alaska',
        'abbreviation': 'AK'
      },
      // {
      //   'name': 'AS-American Samoa',
      //   'abbreviation': 'AS'
      // },
      {
        'name': 'AZ-Arizona',
        'abbreviation': 'AZ'
      },
      {
        'name': 'AR-Arkansas',
        'abbreviation': 'AR'
      },
      {
        'name': 'CA-California',
        'abbreviation': 'CA'
      },
      {
        'name': 'CO-Colorado',
        'abbreviation': 'CO'
      },
      {
        'name': 'CT-Connecticut',
        'abbreviation': 'CT'
      },
      {
        'name': 'DE-Delaware',
        'abbreviation': 'DE'
      },
      {
        'name': 'DC-District Of Columbia',
        'abbreviation': 'DC'
      },
      // {
      //   'name': 'FM-Federated States Of Micronesia',
      //   'abbreviation': 'FM'
      // },
      {
        'name': 'FL-Florida',
        'abbreviation': 'FL'
      },
      {
        'name': 'GA-Georgia',
        'abbreviation': 'GA'
      },
      // {
      //   'name': 'GU-Guam',
      //   'abbreviation': 'GU'
      // },
      {
        'name': 'HI-Hawaii',
        'abbreviation': 'HI'
      },
      {
        'name': 'ID-Idaho',
        'abbreviation': 'ID'
      },
      {
        'name': 'IL-Illinois',
        'abbreviation': 'IL'
      },
      {
        'name': 'IN-Indiana',
        'abbreviation': 'IN'
      },
      {
        'name': 'IA-Iowa',
        'abbreviation': 'IA'
      },
      {
        'name': 'KS-Kansas',
        'abbreviation': 'KS'
      },
      {
        'name': 'KY-Kentucky',
        'abbreviation': 'KY'
      },
      {
        'name': 'LA-Louisiana',
        'abbreviation': 'LA'
      },
      {
        'name': 'ME-Maine',
        'abbreviation': 'ME'
      },
      // {
      //   'name': 'MH-Marshall Islands',
      //   'abbreviation': 'MH'
      // },
      {
        'name': 'MD-Maryland',
        'abbreviation': 'MD'
      },
      {
        'name': 'MA-Massachusetts',
        'abbreviation': 'MA'
      },
      {
        'name': 'MI-Michigan',
        'abbreviation': 'MI'
      },
      {
        'name': 'MN-Minnesota',
        'abbreviation': 'MN'
      },
      {
        'name': 'MS-Mississippi',
        'abbreviation': 'MS'
      },
      {
        'name': 'MO-Missouri',
        'abbreviation': 'MO'
      },
      {
        'name': 'MT-Montana',
        'abbreviation': 'MT'
      },
      {
        'name': 'NE-Nebraska',
        'abbreviation': 'NE'
      },
      {
        'name': 'NV-Nevada',
        'abbreviation': 'NV'
      },
      {
        'name': 'NH-New Hampshire',
        'abbreviation': 'NH'
      },
      {
        'name': 'NJ-New Jersey',
        'abbreviation': 'NJ'
      },
      {
        'name': 'NM-New Mexico',
        'abbreviation': 'NM'
      },
      {
        'name': 'NY-New York',
        'abbreviation': 'NY'
      },
      {
        'name': 'NC-North Carolina',
        'abbreviation': 'NC'
      },
      {
        'name': 'ND-North Dakota',
        'abbreviation': 'ND'
      },
      // {
      //   'name': 'MP-Northern Mariana Islands',
      //   'abbreviation': 'MP'
      // },
      {
        'name': 'OH-Ohio',
        'abbreviation': 'OH'
      },
      {
        'name': 'OK-Oklahoma',
        'abbreviation': 'OK'
      },
      {
        'name': 'OR-Oregon',
        'abbreviation': 'OR'
      },
      // {
      //   'name': 'PW-Palau',
      //   'abbreviation': 'PW'
      // },
      {
        'name': 'PA-Pennsylvania',
        'abbreviation': 'PA'
      },
      // {
      //   'name': 'PR-Puerto Rico',
      //   'abbreviation': 'PR'
      // },
      {
        'name': 'RI-Rhode Island',
        'abbreviation': 'RI'
      },
      {
        'name': 'SC-South Carolina',
        'abbreviation': 'SC'
      },
      {
        'name': 'SD-South Dakota',
        'abbreviation': 'SD'
      },
      {
        'name': 'TN-Tennessee',
        'abbreviation': 'TN'
      },
      {
        'name': 'TX-Texas',
        'abbreviation': 'TX'
      },
      {
        'name': 'UT-Utah',
        'abbreviation': 'UT'
      },
      {
        'name': 'VT-Vermont',
        'abbreviation': 'VT'
      },
      // {
      //   'name': 'VI-Virgin Islands',
      //   'abbreviation': 'VI'
      // },
      {
        'name': 'VA-Virginia',
        'abbreviation': 'VA'
      },
      {
        'name': 'WA-Washington',
        'abbreviation': 'WA'
      },
      {
        'name': 'WV-West Virginia',
        'abbreviation': 'WV'
      },
      {
        'name': 'WI-Wisconsin',
        'abbreviation': 'WI'
      },
      {
        'name': 'WY-Wyoming',
        'abbreviation': 'WY'
      }
    ],
    // '2': [
    //   {
    //     'name': 'AB-Alberta',
    //     'abbreviation': 'AB'
    //   },
    //   {
    //     'name': 'BC-British Columbia',
    //     'abbreviation': 'BC'
    //   },
    //   {
    //     'name': 'MB-Manitoba',
    //     'abbreviation': 'MB'
    //   },
    //   {
    //     'name': 'NB-New Brunswick',
    //     'abbreviation': 'NB'
    //   },
    //   {
    //     'name': 'NL-Newfoundland and Labrador',
    //     'abbreviation': 'NL'
    //   },
    //   {
    //     'name': 'NS-Nova Scotia',
    //     'abbreviation': 'NS'
    //   },
    //   {
    //     'name': 'NT-Northwest Territories',
    //     'abbreviation': 'NT'
    //   },
    //   {
    //     'name': 'NU-Nunavut',
    //     'abbreviation': 'NU'
    //   },
    //   {
    //     'name': 'ON-Ontario',
    //     'abbreviation': 'ON'
    //   },
    //   {
    //     'name': 'PE-Prince Edward Island',
    //     'abbreviation': 'PE'
    //   },
    //   {
    //     'name': 'QC-Québec',
    //     'abbreviation': 'QC'
    //   },
    //   {
    //     'name': 'SK-Saskatchewan',
    //     'abbreviation': 'SK'
    //   },
    //   {
    //     'name': 'YT-Yukon',
    //     'abbreviation': 'YT'
    //   }
    // ],
    '4': []
  }

  export default States